import type { EventParamsType, EventsDictionary } from '../types';

export enum HelpEvents {
  HEADER_MAIN_VIEW = 'header:Main_view',
  HEADER_FAQ_CLICK = 'header:Faq_click',
  HELP_HOME_VIEW = 'helper:Home_view',
  ARTICLE_VIEW = 'helper:Article_view',
  ARTICLE_EXPAND_CLICK = 'helper:Article_expand_click',
  REQUESTING_HELP = 'helper:RequestingHelp_view',
  SEND_HELP_REQUEST_CLICK = 'helper:SendHelpRequest_click',
  CANCEL_HELP_REQUEST_CLICK = 'helper:CancelHelpRequest_click',
  HELP_HEADER_CLICK = 'Header:Help_Click',
  HELP_CLICK = 'helper:HomeClick',
  HELP_HOME_HELP_CLICK = 'helper:HomeHelpClick',
  HELP_CHAT_P1_CLICK = 'helper:HomeChatP1Click',
  HELP_CHAT_CS_CLICK = 'helper:HomeChatCSClick',
  HELP_CHAT_ONB_CLICK = 'helper:HomeChatOnbTimeClick',
  HELP_CLOSE_CLICK = 'helper:HomeCloseClick',
  HELP_ACCESS_FORM_VIEW = 'helper:AccessForm_view',
  HELP_ACCESS_FORM_SUCCESS_VIEW = 'helper:Access_Form_Success_view',
  HELP_HOME_CHAT_CS_CLICK = 'helper:Home_Chat_CS_Click',
  HELP_ACCESS_FORM_CLOSE_CLICK = 'helper:Access_Form_Close_click',
  HELP_ACCESS_FORM_BACK_CLICK = 'helper:Access_Form_Back_click',
  HELP_ACCESS_FORM_FAQ_CLICK = 'helper:Access_Form_FAQ_click',
  HELP_ACCESS_FORM_NEXT_CLICK = 'helper:Access_Form_Next_click',
  HELP_ACCESS_FORM_SUCCESS_CLOSE_CLICK = 'helper:Access_Form_Success_Close_click',
  HELP_ACCESS_FORM_SUCCESS_COPY_CLICK = 'helper:Access_Form_Success_Copy_click',
  HELP_ACCESS_FORM_SUCCESS_NEXT_CLICK = 'helper:Access_Form_Success_Next_click',
  HELP_ACCESS_FORM_ERROR_CALLBACK = 'helper:Access_Form_Error_Callback_click',
}

export type HelpEventsType = typeof HelpEvents;

export type HelpsEventType = keyof HelpEventsType;

export type HelpsEventTypeCollection = HelpsEventType[];

const NEWS_EVENT_KEYS = Object.keys(HelpEvents) as HelpsEventTypeCollection;

export const help: EventsDictionary = NEWS_EVENT_KEYS.reduce((collection, eventKey) => {
  const eventName = HelpEvents[eventKey];

  return {
    ...collection,
    [eventName]: <HELPSEventParams>(params: EventParamsType<HELPSEventParams>) => ({
      name: eventName,
      label: eventName,
      revision: 0,
      metadata: params,
    }),
  };
}, {});
